import { create } from "zustand";
import { io } from "socket.io-client";

const useSocketStore = create((set, get) => ({
  socket: null,
  isConnected: false,

  socketConnect: (url) => {
    console.log("Connecting Socket");
    if (get().socket?.connected) {
      console.log("Socket already connected");
      return;
    }

    const socket = io(url);

    socket.on("connect", () => {
      set({ isConnected: true });
      console.log("Connected: " + socket.id);
    });
    socket.on("disconnect", () => set({ isConnected: false }));

    set({ socket });
  },

  socketDisconnect: () => {
    const { socket } = get();
    if (socket) {
      socket.disconnect();
      set({ socket: null, isConnected: false });
    }
  },
}));

export default useSocketStore;
